import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { IframeFlag } from '@/layout/Default';
import { isRnHost } from '@/utils/approval/isInApp';

/**
 * 앱이 자체 헤더 없이 띄운 화면인지 — 앱 웹뷰(isRNWebview)이면서 `embedded=true` 로 열린 경우.
 *
 * 네이티브 앱은 게시글 상세를 `/board/{id}?embedded=true` 로 열고(앱 헤더·GNB 없음),
 * 운영 중인 RN 앱은 `embedded` 없이 자체 뒤로가기 헤더를 얹어 연다. 둘을 구분해야
 * 네이티브 앱에만 닫기(X)·인쇄 숨김을 적용하고 RN 앱은 기존 그대로 둘 수 있다.
 * SSR 에는 window 가 없어 앱 여부는 effect 에서 읽는다.
 */
export const useIsAppEmbedded = (): boolean => {
  const router = useRouter();
  const [isInApp, setIsInApp] = useState(false);
  useEffect(() => {
    setIsInApp(isRnHost());
  }, []);
  return isInApp && Boolean(router.query[IframeFlag]);
};
